export default "__VITE_ASSET__ce910973__"